export default __webpack_public_path__ + "v3.424/youtube-logo.png";